import script from "./HomePageIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageIndex.vue?vue&type=script&setup=true&lang=js"

import "./HomePageIndex.vue?vue&type=style&index=0&id=57aaeace&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57aaeace"]])

export default __exports__